<template>
  <DashboardMobile v-if="isMobile" />
  <DashboardTablet v-else-if="isTablet" />
  <LoginDashboard v-else />
</template>

<script setup lang="ts">
import { useBreakpoints } from '@vueuse/core'
import LoginDashboard from './loginDashboard.vue'
import DashboardMobile from './DashboardMobile.vue'
import DashboardTablet from './DashboardTablet.vue'

const breakpoints = useBreakpoints({ mobile: 0, tablet: 640, desktop: 1024 })
const isMobile = breakpoints.smaller('tablet')
const isTablet = breakpoints.between('tablet', 'desktop')
</script>
